import { render, staticRenderFns } from "./StripeCustomer.vue?vue&type=template&id=6384bff4&"
import script from "./StripeCustomer.vue?vue&type=script&lang=js&"
export * from "./StripeCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports